import { createComponent } from "@/lib/helpers/admin";
import StepsComponent from "@/template/blocks/Steps";

export const Steps = createComponent({
  label: "Steps",
  component: StepsComponent,
  fields: {
    headingTag: {
      label: "Heading Tag",
      type: "select",
      default: "h1",
      options: [
        { label: "H1 (Default)", value: "h1" },
        { label: "H2", value: "h2" },
        { label: "H3", value: "h3" },
      ],
    },
    heading: {
      label: "Heading",
      type: "textarea",
      default: "Heading",
    },
    description: {
      label: "Description",
      type: "textarea",
      default: "Description",
    },
    isFourColumnLayout: {
      label: "Use 4-column layout",
      type: "boolean",
    },
    stepCard: {
      label: "Step Card",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "textarea",
          default: "Title",
        },
        description: {
          label: "Description",
          type: "textarea",
          default: "Description",
        },
        link: {
          label: "Text Link",
          type: "object",
          objectFields: {
            label: {
              label: "Label",
              type: "textarea",
              default: "Label",
            },
            href: {
              label: "Link",
              type: "textarea",
              default: "/link",
            },
            isButton: {
              label: "Is Button",
              type: "boolean",
            },
          },
        },
        image: {
          label: "Image",
          type: "image",
        },
        showImageOnTop: {
          label: "Place Image Above Content",
          type: "boolean",
        },
      },
    },
    enableCustomBlock: {
      label: "Need Custom Block",
      type: "boolean",
    },
    isContentHeading: {
      label: "Is Custom Block Content Heading",
      type: "boolean",
    },
    content: {
      label: "Content",
      type: "textarea",
    },
    button: {
      label: "Buttons",
      type: "array",
      arrayFields: {
        children: {
          label: "Text",
          type: "textarea",
        },
        flipText: {
          label: "Flip Text",
          type: "textarea",
        },
        link: {
          label: "Link",
          type: "text",
        },
        icon: {
          label: "Icon (optional)",
          type: "icon",
        },
        variant: {
          label: "Variant",
          type: "select",
          options: [
            { label: "Flat", value: "flat" },
            { label: "Solid", value: "solid" },
            { label: "Outline", value: "outline" },
          ],
        },
        target: {
          label: "Open In New Tab",
          type: "select",
          options: [
            { label: "Yes", value: "_blank" },
            { label: "No", value: "_self" },
          ],
        },
        color: {
          label: "Color",
          type: "select",
          options: [
            { label: "Default", value: "default" },
            { label: "Primary", value: "primary" },
            { label: "Secondary", value: "secondary" },
            { label: "Success", value: "success" },
          ],
        },
        title: {
          label: "Title",
          type: "textarea",
        },
        hasEffect: {
          label: "Hover Effect",
          type: "boolean",
        },
      },
    },
    altStyling: {
      label: "Alternative Styling",
      type: "boolean",
    },
  },
});
